import { Quote } from "lucide-react";

// Testimonials adapted from real TerrainHopper customer stories (terrainhopper.com)
const REVIEWS = [
  {
    name: "Trish Brookes",
    where: "Yorkshire Dales (Access The Dales)",
    role: "TerrainHopper hirer",
    body: "After gaining my spinal injury in 2021 I never thought I'd be able to ramble with family again — but how wrong was I. The Overlander 4 gave me my first experience back outdoors. I can't wait to get out again.",
  },
  {
    name: "Sarah",
    where: "United Kingdom",
    role: "Owner",
    body: "Owning a TerrainHopper has given me my independence back. I can now join my family on walks I thought I'd never see again.",
  },
  {
    name: "Cassie",
    where: "Apex Beach, Mildura, VIC",
    role: "Australian trial rider",
    body: "Took the Overlander 4 for a spin at Apex Beach, in Mildura. Verdict? This thing is fantastic.",
  },
];

export default function Testimonials() {
  return (
    <section id="testimonials" data-testid="testimonials" className="relative py-24 md:py-32 bg-muted">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="max-w-3xl">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-primary">
            Real Riders
          </span>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl uppercase tracking-tight font-bold leading-[1.05]">
            From the people <br /> who actually drive it.
          </h2>
          <p className="mt-4 text-sm text-muted-foreground italic">
            Quotes adapted from TerrainHopper&apos;s official customer stories. Australian
            testimonials added as our local fleet expands.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-5">
          {REVIEWS.map((r, i) => (
            <figure
              key={r.name}
              data-testid={`testimonial-${i}`}
              className="bg-card border border-border rounded-sm p-7 md:p-8 flex flex-col"
            >
              <Quote className="h-7 w-7 text-primary" />
              <blockquote className="mt-5 text-base md:text-lg leading-relaxed text-foreground">
                &ldquo;{r.body}&rdquo;
              </blockquote>
              <figcaption className="mt-6 pt-6 border-t border-border">
                <div className="font-display font-semibold uppercase tracking-tight">
                  {r.name}
                </div>
                <div className="mt-1 text-xs uppercase tracking-[0.2em] text-muted-foreground">
                  {r.role} · {r.where}
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
